/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_EVENT_LIST = gql`
query GetListOfCyclone($input: GetListOfCycloneInput) {
  getListOfCyclone(input: $input) {
    data {
      eventId
      status
      exposure
      stormName
      payoutEstimate  
      vmin
      vmax
      date
      country
      category
      closingReason
      blockchainProof
      closedBy {
        email
        firstName
        lastName
      }
    }
    currentPage
    pageSize
    totalCount
    totalPages
  }
}
`;
